<script lang="ts">
    import {onMount, tick} from 'svelte';
    import QuestionnaireNavigationBar from "./questionnaire-components/QuestionnaireNavigationBar.svelte";
    import {push} from "svelte-spa-router";
    import PageBox from "../layouts/PageBox.svelte";
    import ContentBox from "../layouts/ContentBox.svelte";
    import {CategoryModel} from "../models/CategoryModel";
    import {getLocalStorageItem, getQuestionnaire, isAdminUser, triggerEvaluation} from "../utility.js";
    import Subcategory from "./questionnaire-components/Subcategory.svelte";
    import {SubcategoryModel} from "../models/SubcategoryModel";
    import TopThree from "./questionnaire-components/TopThree.svelte";
    import Button from "../ui_elements/Button.svelte";
    import Spinner from "../misc/Spinner.svelte";
    import {QuestionModel} from "../models/QuestionModel";

    export let params; // automatically contains router params

    let box;

    let isAdmin = false;
    let categories: CategoryModel[] = [];

    let currentCategory: number;
    let currentSubcategory: number;

    let svgHeight = 160;

    let category: CategoryModel = null;
    let subcategories: SubcategoryModel[] = [];
    let subcategoryMap: Map<number, SubcategoryModel[]> = new Map<number, SubcategoryModel[]>();

    let childRefs = [];

    let selectedMultipleChoiceOptions = null;

    let categoryDoneScreen: boolean = false;

    let pageTitle = "Fragebogen"
    let pageDescription = "Fragebogen wird geladen...";

    let message = '';
    let err_message = '';


    onMount(async () => {
        const data = await getQuestionnaire();
        categories = data.categories;

        isAdmin = await isAdminUser();

        handleFetch()

        if (currentCategory > categories.length - 2) {
            currentCategory = categories.length - 2;
        }
        //push(`/questionnaire/${currentPage}`);

    });

    const handleFetch = (nextSub?: number, nextCategory?: number) => {
        currentCategory = nextCategory ?? parseInt(params.page);
        currentSubcategory = nextSub ?? parseInt(params.sub);

        console.log("handle fetch with:", currentCategory, currentSubcategory);

        push(`/questionnaire/${currentCategory}/${currentSubcategory}`);

        subcategoryMap = new Map<number, SubcategoryModel[]>();
        category = categories[currentCategory];
        console.log("category:")
        console.log(category)
        msg();


        let count = 0;
        let page = 0;
        for (const subcategory of category.subcategories) {
            let nextPage = false;
            if (subcategory.questions.length <= 0 || !multiPageQuestion(subcategory.questions[0])) {
                nextPage = true;
            } else {
                count += subcategory.questions.length;

                if (count >= 10) {
                    nextPage = true
                }
            }

            let subs = subcategoryMap.get(page);
            if (!subs) subs = [];
            subs.push(subcategory);

            subcategoryMap.set(page, subs);

            if (nextPage) {
                page++;
                count = 0;
            }
        }

        console.log(subcategoryMap);

        childRefs = [];
        subcategories = subcategoryMap.get(currentSubcategory - 1);

        categoryDoneScreen = subcategoryMap.size < currentSubcategory;

        pageTitle = category.category_name;
        pageDescription = category.description;


        if (isMultipleChoiceCategory() && subcategories) {
            selectedMultipleChoiceOptions = getSelectedMultipleChoiceOptions();

            checkIfTopThreeAndLE3AndSkip();
        }

        scrollToTop();
    };

    function msg(text: string = "", error: boolean = false) {
        if (error) {
            message = "";
            err_message = text;
        } else {
            message = text;
            err_message = "";
        }
    }

    function checkIfTopThreeAndLE3AndSkip() {
        if (subcategories && subcategories[0].subcategory_name.includes("TopThree") && selectedMultipleChoiceOptions.length <=3) {
            console.log("is top 3 and less than 3 selected: saving and moving on")
            setTimeout(() => {
                if (saveAndVerifySubmission(false)) {
                    console.log("save succeeded!")
                    forwardAfterSubmission(false);
                } else {
                    console.log("failed to save!");
                }
            }, 200)
        }
    }

    function prev() {
        if (saveAndVerifySubmission(false))
            forwardAfterSubmission(true);
    }

    function next() {
        if (saveAndVerifySubmission(true))
            forwardAfterSubmission(false);
    }

    function forwardAfterSubmission(back: boolean) {
        console.log(currentCategory, currentSubcategory);
        const nextSub = currentSubcategory + (back ? -1 : 1);

        console.log("nextSub:", nextSub);

        if (nextSub > category.subcategories.length + 1) {
            console.log("next sub overflow, going back to list")
            push(`/questionnaire/`)
        } else {
            handleFetch(nextSub);
        }

        if (isMultipleChoiceCategory()) {
            console.log("getting selectedMultipleChoiceOptions");
            selectedMultipleChoiceOptions = getSelectedMultipleChoiceOptions();
        }
    }

    function saveAndVerifySubmission(validate: boolean): boolean {
        let valid = true;
        for (const ref of childRefs) {
            console.log("running save for ref:", ref);
            if (ref && !ref.triggerSubmission(validate)) {
                valid = false;
            }
        }

        if (valid) {
            msg("Deine Antworten wurden gespeichert.");
            return true;
        }

        msg("Antworten konnten nicht gespeichert werden.", true)
        return false;
    }

    function submitQuestionnaire() {
        triggerEvaluation();
        push('/answers');
    }

    function isMultipleChoiceCategory() {
        return category.subcategories[0].questions[0].question_type_id == "MULTIPLE_CHOICE";
    }

    function multiPageQuestion(question: QuestionModel) {
        return (question.question_type_id === "CHOICE" || question.question_type_id === "ABILITY_RATING")
    }

    function backHome() {
        push(`/questionnaire/`)
    }

    function nextCategory() {
        const nextCategory = currentCategory + 1;
        handleFetch(0, nextCategory);
    }

    function startCategory() {
        handleFetch(1);
    }

    function scrollToTop() {
        console.log("scroll to top")
        tick();
        setTimeout(() => {
            if (!box) return;
            console.log("box found!")
            box.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }

    function getSelectedMultipleChoiceOptions() {
        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        const currentAnswers = Object.entries(questionnaireAnswers).filter(([key, _]) => Object.values(category.subcategories).slice(0, -1)
                .map(element => element.subcategory_id.toString()) // get array of all subcategory IDs in current category
                .includes(key.toString())); // get all questionnaire answers that have a subcategory ID that's in the current category

        console.log(currentAnswers)
        // todo: currentanswers includes last at the moment which is top three
        let optionsArray = [];
        // get all the selected options in one flat array
        currentAnswers.forEach(([_, value]) => {
            const answerString = Object.values(value)[0];
            console.log(answerString)
            try {
                const parsedArray = JSON.parse(answerString);
                optionsArray.push(...parsedArray);
            } catch (error) {
                console.error('Error parsing JSON');
                console.error(answerString);
            }

        });
        return optionsArray;
    }

</script>

<PageBox pageTitle={pageTitle} description={pageDescription}>
    <div bind:this={box}></div>
    {#if category}
        {#key category} <!-- for forcing the component to update when the page changes -->
            {#key subcategories} <!-- for forcing the component to update when the page changes -->
                <ContentBox>
                    {#if categoryDoneScreen}
                        <div class="relative">
                            <h1 class="font-extrabold text-center text-2xl absolute mt-24 w-[100%]">Kategorie
                                "{category.category_name}" abgeschlossen!</h1>
                            <img class="mx-auto" src="/assets/confetti.gif" style="height: 270px" alt="Konfetti">
                        </div>

                        {#if categoryDoneScreen && category.category_id !== 7 }
                            <Button on:click={backHome} className="mt-2 float-left" variant="default">Zurück zur
                                Übersicht
                            </Button>
                            <Button on:click={nextCategory} className="mt-2 ml-auto" variant="submit">Weiter zur
                                nächsten Kategorie
                            </Button>
                        {:else}
                            <Button on:click={backHome} className="mt-2 ml-auto" variant="submit">Zurück zur Übersicht
                            </Button>
                        {/if}

                    {:else if currentSubcategory === 0}
                        <h1 class="font-bold">{category.category_name}</h1>
                        <p class="font-bold">{category.description}</p>
                        <p>{category.extended_description}</p>

                        {#if category.category_name === 'Interessen'}
                            <div class="flex mr-5">
                                <div>
                                    <p>Bitte wähle aus, wie sehr dich die folgenden Tätigkeiten interessieren.</p>

                                    <br>
                                    <b>1</b>: interessiert mich <b>gar nicht</b><br>
                                    <b>2</b>: interessiert mich <b>wenig</b><br>
                                    <b>3</b>: interessiert mich <b>mittel</b><br>
                                    <b>4</b>: interessiert mich <b>schon</b><br>
                                    <b>5</b>: interessiert mich <b>sehr</b><br>
                                </div>

                                <svg viewBox="0 0 400 {svgHeight + 45}" preserveAspectRatio="xMinYMin meet" width=400>
                                    <polygon points="400,100 400,{svgHeight} 0,{svgHeight}" fill="#fde68a"/>
                                    <text x=0 y={svgHeight + 15}>gar nicht</text>
                                    <text x=360 y={svgHeight + 15}>sehr <b>5</b></text>
                                    <text x=0 y={svgHeight + 34} font-weight="bold">1</text>
                                    <text x=380 y={svgHeight + 34} font-weight="bold">5</text>
                                </svg>
                            </div>
                        {/if}

                        <Button on:click={backHome} className="mt-2 float-left" variant="default">Zurück zur Übersicht
                        </Button>
                        <Button on:click={startCategory} className="mt-2 ml-auto" variant="submit">Weiter</Button>
                    {:else}
                        {#each subcategories as subcategory, index}
                            {#if !subcategory.subcategory_name.includes("TopThree")}
                                <div class="text-secondary-text font-bold text-lg">{subcategory.subcategory_name}</div>
                                <Subcategory subcategoryID={subcategory.subcategory_id}
                                             categoryName={category.category_name}
                                             {isAdmin}
                                             questions={subcategory.questions}
                                             bind:this={childRefs[index]}
                                />

                            {:else if isMultipleChoiceCategory()}
                                <TopThree subcategoryID={subcategory.subcategory_id} questions={subcategory.questions}
                                          selected={selectedMultipleChoiceOptions} bind:this={childRefs[index]}/>
                            {/if}
                        {/each}

                        <Button on:click={prev} className="mt-2 float-left" variant="default">Zurück</Button>
                        <Button on:click={next} className="mt-2 float-right" variant="submit">Weiter</Button>
                        <div style="height: 40px">
                            {#if message}
                                <div>{message}</div>
                            {/if}
                            {#if err_message}
                                <div class="text-red-600">{err_message}</div>
                            {/if}
                        </div>


                    {/if}
                </ContentBox>

            {/key}
        {/key}
    {:else}
        <ContentBox>
            Fragen werden geladen...
            <Spinner></Spinner>
        </ContentBox>
    {/if}
    <QuestionnaireNavigationBar slot="questionnaire-navigation-bar">

    </QuestionnaireNavigationBar>

</PageBox>
